import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-badrequest',
  templateUrl: './badrequest.component.html',
  styleUrls: ['./badrequest.component.css']
})
export class BadrequestComponent implements OnInit {
  public messages;
  public message;
  constructor(private route: Router, private http: HttpClient) { }

  ngOnInit() {
   this.messages = {
      '/badrequest': {
        icon: 'mood_bad',
        description: `Problème serveur.<br>
          Veuillez vérifier avec l'administrateur.`,
        refresh: true
      },
      '/security': {
        icon: 'warning',
        description: `Mode Dev a été désactivé pour des raisons de sécurité`,
        refresh: true
      },
  }
    this.message = this.messages[this.route.url];
    if(this.route.url == '/security') {
      const {userName} = JSON.parse(localStorage.getItem(environment.oauth.remoteUser));
      this.http.get(`${environment.api.myshiftUrl}/audit?user=${userName}`).subscribe((status) => {

      });
    }
  }
  public goBack() {
    history.back();
  }
}



// WEBPACK FOOTER //
// ./src/app/view/badrequest/badrequest.component.ts